/**
 * An enum to specify which types of molecules to show in the FormSelectMolecule component.
 */
export var MoleculeTypeFilter;
(function (MoleculeTypeFilter) {
    MoleculeTypeFilter["Protein"] = "protein";
    MoleculeTypeFilter["Compound"] = "compound";
    MoleculeTypeFilter["All"] = "all";
})(MoleculeTypeFilter || (MoleculeTypeFilter = {}));
